import React, { useEffect } from "react";
import RapiDocReact from "../components/RapidDocReact";
import { Box } from "@mui/material";
import Grid from '@mui/material/Grid2';
import TitleDescription from "../components/TitleDescription";
import Title from "../components/Title";
import TitleDescriptionImage from "../components/TitleDescriptionImage";
import { ReactComponent as FinancialDataIntegrationComponent } from "../assets/financial-data-integration.svg"
import { ReactComponent as FinancialAssetCoverageComponent } from "../assets/financial-asset-coverage.svg"
import { ReactComponent as FinsenseSequenceDiagramComponent } from "../assets/finsense-sequence-diagram.svg"
import { ReactComponent as FinancialInsightsComponent } from "../assets/financial-insights.svg"
import { useLocation } from "react-router-dom";

function navigateToSection(hash: string) {
    const element = document.getElementById(hash);
    if (element) {
        var headerOffset = 45;
        var elementPosition = element.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.scrollY - headerOffset;
        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }
}

const FinsensePage: React.FC = React.memo(() => {
    const location = useLocation();
    useEffect(() => {
        if (location.hash.length === 0) {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            })
            return;
        }

        const hash = location.hash.slice(1);
        navigateToSection(hash);
    }, [location.hash]);

    return <>
        <Box sx={{
            paddingLeft: 4
        }}>
            <TitleDescription title="Finsense" description="Finsense enables institutions to seamlessly integrate into the Account Aggregator (AA) ecosystem as Financial Information Users( FIUs). The platform supports you to connect with multiple Account Aggregator to receive information when the user gives consent. Finsense offers a range of advanced features." />
            <>
                <Title title="Why Finsense?" />
                <Grid container spacing={3} paddingTop={1}>
                    <Grid size={4}>
                        <TitleDescriptionImage
                            title="AA Switch"
                            description="In Multi Account Aggregator (AA) integration, optimize the data fetch and consent traffic to Account Aggregator that has high availability and success rate for preferred FIP. This algorithmic and rule based AA selection improves the data fetch success rate and provides a comprehensive coverage of FIP."
                            svg={FinancialDataIntegrationComponent}
                            maxWidth={290}
                        />
                    </Grid>
                    <Grid size={4}>
                        <TitleDescriptionImage
                            title="MIS & Tracking"
                            description="The self-service portal provides a metrics dashboard for tracking key metrics, including consent and Financial Information Provider (FIP) metrics, consent and data fetch statuses, and the ability to re-trigger these processes when needed."
                            svg={FinancialAssetCoverageComponent}
                            maxWidth={290}
                        />
                    </Grid>
                    <Grid size={4}>
                        <TitleDescriptionImage
                            title="Data Enrichment"
                            description="Finsense offers advanced data enhancement options, including data duplication check, cleansing invalid characters, and standardizing date formats to ensure data consistency and accuracy for a more reliable user experience."
                            svg={FinancialInsightsComponent}
                            maxWidth={290}
                        />
                    </Grid>
                </Grid>
            </>
            <>
                <Title title="How Finsense Works - Sequence Diagram" paddingBottom={4} paddingTop={6} />
                <FinsenseSequenceDiagramComponent />
            </>
        </Box>
        <RapiDocReact
            spec-url={"./api-docs/finsense-api-docs.json"}
            show-info={false}
            show-header={false}
            render-style="view"
            primary-color="#4D2FA3"
            bg-color="#FAFBFC"
            schema-style="table"
            regular-font='"Roboto","Helvetica","Arial",sans-serif'
            mono-font='"Roboto","Helvetica","Arial",sans-serif'
            schema-description-expanded={true}
        >
            <span id="auth" slot="servers" /> {/* Hack to scroll to right place */}
            <span id="subscription" slot="tag--Subscription" />
            <span id="consent-flow" slot="tag--Consent-Flow" />
            <span id="data-flow" slot="tag--Data-Flow" />
            <span id="metrics-api" slot="tag--Metrics-API" />
            <span id="notification" slot="tag--Notification" />
            <span id="supporting-apis" slot="tag--Supporting-APIs" />
            <span id="rbih" slot="tag--RBiH" />
            <span id="aa-switch-api" slot="tag--AA-Switch-API" />
            <span id="others" slot="tag--Others" />
        </RapiDocReact>
    </>
});

export default FinsensePage;
